export default __webpack_public_path__ + "static/media/87.3f85d4ac.jpg";